import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import "./../../../css/app.css";

const ToggleButton = (props) => {
  const mac = mqtt_topics.choosenmac;
  const [state, setState] = useStateIfMounted({
    title: props.title, //"Normal UI"
    disabled: false, //if returned value == na set to false
    acc: props.acc,
  });
  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    "/" +
    props.subcategory +
    "/" +
    props.title; //+mqtt_topics.Readings_topic +state.title

  function listenforlivedata() {
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == target_live_reading_topic) {
      try {
        // message is Buffer
        message = JSON.parse(message.toString());
        if (message.value.toLowerCase().toString() == "nv") {
          setState({
            ...state,
            disabled: false,
          });
        } else {
          setState({
            ...state,
            //value: message.value == undefined ? 0 : message.value,
            disabled: true,
          });
        }
      } catch (error) {
        //console.log(message);
      }
    }
  }

  useEffect(() => {
    //listenforlivedata();
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  function setparameter() {
    if (!mqtt_topics.busy_Requesting_Data) {
      requestdata();
    } else {
      setTimeout(function () {
        requestdata();
      }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
    }
  }

  function requestdata() {
    mqtt_topics.busy_Requesting_Data = true;
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      JSON.stringify({
        param: props.category + "/" + props.subcategory + "/" + props.title,
        value: "clicked " + props.title,
      })
    );
    mqtt_topics.busy_Requesting_Data = false;
  }

  return (
    <div className="grid-item">
      <button
        onClick={() => setparameter()}
        className="btn btn-dark btn-sm"
        style={{ width: "13vw", height: "2rem" }}
        disabled={!state.acc}
      >
        {state.title}
      </button>
    </div>
  );
};
export default ToggleButton;
